import React, { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router";
import Header from "./Header";
import Footer from "../Footer";
import fire from "./Firebase";
import "../App.css";

function CertificateTemp2() {
  document.title = "HR School-Template2";

  const conponentPDF = useRef();
  const [certificate, setcertificate] = useState({});
  const [search1, setsearch1] = useState("");
  const [search2, setsearch2] = useState({});
  const [search3, setsearch3] = useState([]);

  useEffect(() => {
    fire.child("certificates").on("value", (data) => {
      if (data.val() == null || data.val() == "") alert("Data Fetch");
      else {
        setcertificate(data.val());
      }
      console.log(data.val());
    });
  }, []);
  useEffect(() => {
    fire.child("certificates").on("value", (data2) => {
      if (data2.val() == null || data2.val() == "") alert("Data Fetch");
      else {
        setsearch2(data2.val());
      }
      console.log(data2.val());
    });
  }, []);
  useEffect(() => {
    Object.keys(search2).map((setall) => {
      setsearch3(search2[setall]);
      console.log(search2[setall]);
    });
  }, [search2]);

  function check(e) {
    setsearch1({ ...search1, [e.target.name]: e.target.value });
  }
  function find() {
    if (search1.search == search3.Name) {
      console.log(search3.Name);
      console.log(search1.search);
      alert("find");
    } else {
      alert("not find");
    }
  }
  // const generatePDF = useReactToPrint({
  //   // content: () => conponentPDF.current,
  //   // documentTitle: "Userdata",
  //   // onAfterPrint: () => alert("Data saved in PDF"),
  //   console.log(first)
  // });
  const navigate = useNavigate();
  function generatePDF(keys) {
    sessionStorage.setItem("lastname2", keys);
    navigate("/try2");
  }
  return (
    <div>
      <Header />
      <center>
        <div>
          <h1>Download PDF Certificate</h1>
          <input type="text" onChange={check} name="search" />
          <button onClick={find}>find</button>
          <div id="maindiv" ref={conponentPDF}>
            {Object.keys(certificate).map((all, index) => {
              return (
                <>
                  <div id="certificatebox2" className="print" style={{textTransform:"uppercase"}}>
                    <div className="containernew">
                      <div id="certificate">
                        <div className="cert">
                          <div className="cert-header">
                            <div className="cert-logo">
                              <div className="cert-logo-name">
                                HR School
                                <br />
                              </div>
                            </div>

                            <div className="cert-title">
                              CERTIFICATE OF COMPLETION
                            </div>
                            <div className="cert-no">
                              CERTIFIED {certificate[all].Field} SPECIALIST
                            </div>
                          </div>

                          <div className="cert-content">
                            <div className="cert-label">
                              THIS IS TO CERTIFY THAT
                            </div>{" "}
                            <br />
                            <div className="cert-user">
                              <div className="cert-user-name">
                                NAME :- {certificate[all].Gender} {certificate[all].Name}
                              </div>{" "}
                              <br />
                              <div className="cert-user-info">
                                FATHER NAME :- {certificate[all].Father}
                              </div>{" "}
                              <br />
                              <div className="cert-user-info">
                                COURSE DURATION :- {certificate[all].Course} MONTHS
                              </div>{" "}
                              <br />
                              <div className="cert-user-info">
                                COURSE NAME :- {certificate[all].Coursename}
                              </div>{" "}
                              <br />
                            </div>
                            <div className="cert-achievement">
                              THE BEAUTIFUL THING ABOUT LEARNING IS THAT NO ONE
                              CAN TAKE IT AWAY FROM YOU.
                            </div>{" "}
                            <br />
                            <br />
                            <div className="cert-signature">
                              <div>
                                HAS SUCCESSFULLY COMPLETED THE{" "}
                                {certificate[all].Coursename} COURSE WITH HR
                                SCHOOL
                              </div>{" "}
                              <br />
                              <div className="cert-signature-sign"></div>
                              <div>
                                <div style={{ fontWeight: "bold" }}>
                                  WITH SCORE OF {certificate[all].grade}
                                </div>{" "}
                                <br />
                                <div style={{ fontWeight: "bold" }}>Dated</div><br />
                              </div>
                              <div>
                                START DATE :- {certificate[all].startdate} /
                        {certificate[all].startmonth} /
                        {certificate[all].startyear}
                              </div>
                              <br />
                              <div>END DATE :-{certificate[all].enddate} /
                        {certificate[all].endmonth}/{certificate[all].endyear}</div>
                            </div>
                          </div>

                          <div className="cert-footer">
                            <div className="cert-qr">
                              <div className="cert-qr-image"></div>
                            </div>
                            <div className="cert-qr-label">
                              www.hrschool.com
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <center>
                      {" "}
                      <br />
                      <button onClick={() => generatePDF(all)}>
                      Download {certificate[all].Name} Image
                      </button>
                    </center>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </center>
      <Footer />
    </div>
  );
}

export default CertificateTemp2;
